'use strict';

const DISPLAY = {
  SUBMITTER: 'Application Submitter',
  PRIMARY_CONTACT: 'Primary Contact',
  ALTERNATE_CONTACT: 'Alternate Contact',
  PRIMARY_SUPERVISOR: 'Primary Supervisor',
  ROLE_CAMPUS_ADMIN: 'EHS Liaison',
  ROLE_UCOP_ADMIN: 'UCOP EHS',
  PRIMARY_PURCHASER: 'Primary Purchaser',
  ALTERNATE_PURCHASER: 'Alternate Purchaser',
};

module.exports = DISPLAY;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/server/shared/constants/display.constant.js
// module id = qgjB
// module chunks = 1